import { OrdersView } from "../views/Orders/OrdersView";
import { OrderSettings } from "../views/Orders/OrderSettings";
import OrdersHistory from "../views/OrdersHistory/OrdersHistory";
import OrdersGraph from "../views/OrdersGraph/OrdersGraph";
import { SupplyNotes } from "../views/SupplyNotes/SupplyNotes";
import { NotesFlotilla } from "../views/NotesFlotilla/NotesFlotilla";
import Issues_L from "views/Issues/lazy";
import { Promocodes } from "views/Promocodes/PromocodesPage";


import AssignmentIcon from "@material-ui/icons/Assignment";
import { orderTypes } from "redux/reducers/orders/orderTypes";

const ordersErrorConf = {
  reducer: "orders",
  restoreKey: orderTypes.RESTORE_INITIAL
}

export const orderRoutes = [
  {
    collapse: true,
    name: "Pedidos",
    icon: AssignmentIcon,
    state: "ordersSection",
    inSidebar: true,
    isProtected: true,
    rule: "ORDERS",
    views: [
      {
        path: "/seguimiento_pedidos",
        name: "Seguimiento de pedidos",
        mini: "SP",
        component: OrdersView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "ORDERS",
        ...ordersErrorConf
      },
      {
        path: "/seguimiento_pedido_orden/:id",
        component: OrderSettings,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: "ORDERS",
        ...ordersErrorConf
      },
      {
        path: "/historico_pedidos",
        name: "Historico de ventas",
        mini: "US",
        component: OrdersHistory,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "HISTORY",
        adenda: false,
      },
      {
        path: "/graficas_pedidos",
        name: "Graficas de pedidos",
        mini: "GP",
        component: OrdersGraph,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "ORDERSGRAPH",
      },
      {
        path: "/notas_surtido",
        name: "Ubicación Notas de surtido",
        mini: "NS",
        component: SupplyNotes,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "ORDERS-NOTES",
      },
      {
        path: "/notas_flotilla",
        name: "Notas de flotilla",
        mini: "NF",
        component: NotesFlotilla,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "ORDERS-FLOTILLA",
      },
      {
        path: "/issues",
        name: "Quejas y Fugas",
        mini: "QF",
        component: Issues_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "ISSUES",
      },
      {
        path: "/promocodes",
        name: "Cupones",
        mini: "CP",
        component: Promocodes,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "COUPONS",
      },
    ],
  },
]